import React, { FC } from "react";
import isEmpty from "lodash/isEmpty";
import { FILTER_TYPES } from "../constants";
import FilterRangeMob from "@/routes/productListing/productListingFiltersMob/filterRangeMob";
import FilterMultiSelectMob from "@/routes/productListing/productListingFiltersMob/filterMultiSelectMob";
import FilterSizeMob from "@/routes/productListing/productListingFiltersMob/filterSizeMob";
import FilterCategoryMob from "@/routes/productListing/productListingFiltersMob/filterCategoryMob";
import MoreFiltersPlaceholder from "@/routes/productListing/productListingFiltersMob/moreFiltersPlaceholder";
import {
  CategoryFacet,
  Facet,
  FilterType,
  GeneralFacet,
  MultiSelectFacet,
  PriceFacet,
  PriceFilterOption,
  SizeFacet
} from "../types";

type FilterProps = {
  filter: Omit<Facet, "sortOrder">;
  setToggledFilter: (filter: FilterType) => void;
  toggledFilter: FilterType | null;
  onApplyButtonClick: (...args) => void;
  onSelectCategory?: () => void;
  selectedCategoryCount?: number;
};

const FilterContainer: FC<FilterProps> = ({
  filter,
  setToggledFilter,
  toggledFilter,
  onApplyButtonClick,
  onSelectCategory,
  selectedCategoryCount
}) => {
  if ((filter as any).type === FILTER_TYPES.MORE_FILTERS) {
    return (
      <MoreFiltersPlaceholder
        onSelectCategory={onSelectCategory ?? (() => {})}
        selectedCategoryCount={selectedCategoryCount}
      />
    );
  }

  if (isEmpty(filter?.data)) throw new Error();

  switch (filter.type) {
    case FILTER_TYPES.MULTI_SELECT:
      return (
        <FilterMultiSelectMob
          filter={filter as GeneralFacet & MultiSelectFacet}
        />
      );
    case FILTER_TYPES.CATEGORY:
      return (
        <FilterCategoryMob
          filter={filter as GeneralFacet & CategoryFacet}
          setToggledFilter={setToggledFilter}
          toggledFilter={toggledFilter}
          onApplyButtonClick={onApplyButtonClick}
        />
      );
    case FILTER_TYPES.PRICE:
      return (
        <FilterRangeMob
          filter={filter as GeneralFacet & PriceFacet}
          setToggledFilter={setToggledFilter}
          toggledFilter={toggledFilter}
        />
      );
    case FILTER_TYPES.SIZE:
      return (
        <FilterSizeMob
          filter={filter as GeneralFacet & SizeFacet}
          setToggledFilter={setToggledFilter}
          toggledFilter={toggledFilter}
        />
      );

    default:
      return null;
  }
};

export default FilterContainer;
